import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
    main: {
        justifyContent: "center",
        marginTop: theme.spacing(1)
    },
    event: {
        display: "flex",
        alignItems: "center"
    },
    eventDetails: {
        fontSize: "1.5em",
        padding: "0 !important",
        "& b": {
            color: theme.palette.text.disabled
        },
        "&>div>div>div":{
            padding: theme.spacing(2)
        }
    },
    [theme.breakpoints.down('xs')]: {
        eventDetails: {
            fontSize: "1em"
        }
    }
}))